module.exports = __webpack_public_path__ + "e6ce7eb9f5539acb2ff7ccf9cfde57f9.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/clowns-cabin-empty.png
// module id = 316
// module chunks = 0